import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var BannerListRes;
export const BannerListTodo = createAsyncThunk('BannerList', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Get",
            url: process.env.REACT_APP_API_URL + 'banner_data',
            params:{
                "banner_status": ""
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return BannerListRes = res.data

    } catch (error) {
        return BannerListRes = error.response.data
    }
})

const BannerListSlice = createSlice({
    name: 'BannerList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(BannerListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(BannerListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default BannerListSlice.reducer; 